export default {
    dependencies: ['$element', 'trackingservice'],
    callable(el, trackingService) {
        const openSwitch = el.querySelector('[data-open-trigger]');

        if (openSwitch !== null) {
            openSwitch.addEventListener('click', event => {
                el.classList.toggle('open');
                event.preventDefault();
                if (el.classList.contains('open')) {
                    _trackEvent('promotions.profile.click');
                }
            });
        }

        function _buildObject(name, flags) {
            return {
                analyticsName: name,
                eventFlags: flags,
                eventData: {
                    position: getPosition(),
                },
            };
        }

        function _trackEvent(name) {
            const eventObj = _buildObject(name, 'start');
            trackingService.trackEventObject(eventObj);
        }

        function getPosition() {
            const position = el.parentNode.getAttribute(
                'data-extended-profile-position'
            );
            return position ? position : 'position-missing';
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/extendedProfile.js